import React from 'react';
import { Database, BadgeCheck } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import BlingERP from '../components/BlingERP';

const SCHEMA = {
  "@type": "Service",
  "serviceType": "Implantação e suporte Bling ERP",
  "provider": { "@type": "LocalBusiness", "name": "Fernando Tech", "areaServed": "Ribeirão Preto e região" },
  "description": "Parceiro Bling: implantação, migração, emissão de NF-e e suporte do Bling ERP para pequenas e médias empresas.",
};

const FAQ = [
  { q: "O que é o Bling ERP?", a: "É um sistema de gestão online para emissão de NF-e, controle de estoque, financeiro e integração com marketplaces e e-commerce." },
  { q: "A Fernando Tech implanta o Bling?", a: "Sim. Ajudamos na contratação, configuração, migração de dados e suporte contínuo do Bling." },
  { q: "O Bling integra com marketplaces?", a: "Sim. Integra com Mercado Livre, Shopee, lojas virtuais e diversos marketplaces." },
  { q: "Preciso de conhecimento técnico para usar o Bling?", a: "Não. Nós configuramos e treinamos sua equipe para usar o sistema no dia a dia." },
  { q: "Vocês migram meus dados do sistema antigo?", a: "Sim. Fazemos a migração de cadastros e informações para o Bling com segurança." },
];

export default function BlingPage() {
  return (
    <SubjectPageLayout
      path="/bling"
      breadcrumbName="Bling ERP"
      breadcrumbIcon={<Database className="w-3.5 h-3.5" />}
      seoTitle="Bling ERP — Parceiro Oficial e Suporte | Fernando Tech Ribeirão Preto"
      seoDescription="Implantação, migração e suporte do Bling ERP com a Fernando Tech: emissão de NF-e, controle de estoque, financeiro e integração com marketplaces. Atendimento em Ribeirão Preto e região."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Parceiro Bling',
        badgeIcon: <BadgeCheck className="w-3.5 h-3.5" />,
        title: 'Bling ERP',
        accent: 'sua empresa organizada e no controle',
        subtitle: 'Emissão de NF-e, estoque, financeiro e integrações com marketplaces. A Fernando Tech implanta, migra e dá suporte no Bling para o seu negócio.',
      }}
      cta={{ heading: 'Quer implantar o Bling na sua empresa?', text: 'A Fernando Tech ajuda na contratação, migração e no dia a dia do Bling ERP. Fale com a gente.' }}
    >
      <BlingERP />
    </SubjectPageLayout>
  );
}
